angular.module('logbook').directive('routeLoadingIndicator', ['$rootScope', '$timeout', '$location', 'logService', 'simulateLogUserRoleService', function($rootScope, $timeout, $location, logService, simulateLogUserRoleService) {

  return {
    restrict:'E',
    template:'<div ng-if="isRouteLoading" style="text-align: center;"><i style="font-size: 1000%;" class="fa fa-cog fa-spin"></i></div>',
    link:function(scope, elem, attrs){
      var previousTitle = '';
      scope.isRouteLoading = false;

      $rootScope.$on('$routeChangeStart', function(){
        previousTitle = $rootScope.title;
        $rootScope.title = 'Loading...';
        $timeout.cancel(scope.loadingHandle);
        if( $rootScope.selectedLog
            && $rootScope.selectedLog.millisToFeatureExpiration['LogBook'] != null
            && $rootScope.selectedLog.millisToFeatureExpiration['LogBook'] <= 0 )
        {
           if( !simulateLogUserRoleService.forceAdminFlag )
           {
              logService.selectLog(null, () => $location.url('/logs'));
              throw new Error('Payment for LogBook has expired. You will be redirected to the log list.');
           }
        }
        scope.loadingHandle = $timeout(
           function() {scope.isRouteLoading = true;},
           100);
      });

      $rootScope.$on('$routeChangeSuccess', function(){
        $timeout.cancel(scope.loadingHandle);
        scope.isRouteLoading = false;
      });

      $rootScope.$on('$routeChangeError', function(){
         $timeout.cancel(scope.loadingHandle);
         if (typeof previousTitle === 'string' && previousTitle.length > 0 && previousTitle !== 'Loading...')
         {
             $rootScope.title = previousTitle;
             previousTitle = '';
         }
         scope.isRouteLoading = false;
       });
}
  };
}]);
